var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":require("../../assets/svg/no_data_place_holder.svg"),"alt":"Здесь пусто"}}),_c('p',[_vm._v("Здесь пусто")])])}]

export { render, staticRenderFns }